import axios from 'axios';
import format from 'date-fns/format';

import {
  FETCH_EXPENSES_PREPAID,
  FETCH_EXPENSES_PREPAID_SUCCESS,
  FETCH_EXPENSES_PREPAID_ERROR,
  API_DATE_FORMAT,
} from './constants';

const formatDate = (date) => format(date, API_DATE_FORMAT);

export function fetchExpensesPrepaidStart() {
  return {
    type: FETCH_EXPENSES_PREPAID,
  };
}

export function fetchExpensesPrepaidSuccess(data) {
  return {
    type: FETCH_EXPENSES_PREPAID_SUCCESS,
    data,
  };
}

export function fetchExpensesPrepaidError(error) {
  return {
    type: FETCH_EXPENSES_PREPAID_ERROR,
    error,
  };
}

export function fetchExpensesPrepaid(selectedTab) {
  return (dispatch, getState) => {
    dispatch(fetchExpensesPrepaidStart());
    const { detalizationNew: { periodSelection } } = getState();
    const aggregatorCodes = selectedTab.map((x) => `aggregatorCodes=${x}`).join('&');

    axios.get(`/api/profile/detalization/expenseprepaid?${aggregatorCodes}`, {
      params: {
        periodStart: formatDate(periodSelection.startPeriod),
        periodEnd: formatDate(periodSelection.endPeriod),
      },
    })
      .then(({ data }) => {
        if (data.error) {
          dispatch(fetchExpensesPrepaidError(data.error));
        } else {
          dispatch(fetchExpensesPrepaidSuccess(data));
        }
      })
      .catch((error) => { dispatch(fetchExpensesPrepaidError(error, true)); });
  };
}
